import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'morva-linear-notifiction',
  templateUrl: './linear-notification.component.html',
  styleUrls: ['./linear-notification.component.scss'],
})
export class LinearNotificationComponent implements OnInit {
  @Input() messageType: 'success' | 'error' | 'info' | 'warning' |'importError';
  @Input() message: string;
  @Input() themeType = 'v1';
  @Input() defaultColor: string;
  @Output() changeColor = new EventEmitter();
  colors = {
    success: '#27AE60',
    info: '#009FE3',
    error: '#DD2828',
    warning: '#FFB800',
  };
  icons = {
    success: 'success',
    info: 'info',
    error: 'error',
    importError: 'closeCircleRed',
    warning: 'warning',
  };
  selected = { icon: '', color: '' };
  backgroundColor = ''

  constructor() {
  }

  ngOnInit(): void {
    this.setType();
  }

  setType() {
    switch (this.messageType) {
      case 'success':
        this.selected.color = this.defaultColor ?? this.colors.success;
        this.selected.icon = this.icons.success;
        break;
      case 'info':
        this.selected.color = this.defaultColor ?? this.colors.info;
        this.selected.icon = this.icons.info;
        break;
      case 'error':
        this.selected.color = this.defaultColor ?? this.colors.error;
        this.selected.icon = this.icons.error;
        break;
      case 'importError':
        this.selected.color = this.defaultColor ?? this.colors.error;
        this.selected.icon = this.icons.importError;
        break;
          
      case 'warning':{
        if(this.themeType === 'v2'){
          this.selected.color = this.defaultColor ?? '#808080';
          this.backgroundColor = '#FFB8001A';
        }else{
          this.selected.color = this.defaultColor ?? this.colors.warning;
        }
        this.selected.icon = this.icons.warning;
      }
    }
    this.changeColor.emit(this.messageType);
  }

}
